
export function cleanObject(value?: any | null): any {
  value ||= {};
  Object.keys(value).forEach(key => !value[key] && delete value[key]);
  return value;
}
